export default __webpack_public_path__ + "static/media/PPI-patio-013.11975f8c.jpg";